export default __webpack_public_path__ + "static/media/Company1.e4eb5c4f.png";